import { CategoryGrid, MegaCategories } from "@/components/marketplace"
import type { CategoryGridSection } from "@/features/feed/contract"
import { mapFeedCategoryItem } from "@/features/feed/map-product"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"
import { paletteForCategoryHandle } from "@/features/feed/theme"

export const CategoryGridFeedSection = ({ section, context }: FeedSectionProps<CategoryGridSection>) => {
  const items = section.data.items.map((item) => ({
    ...mapFeedCategoryItem(item, context.countryCode),
    palette: item.link.kind === "CATEGORY" ? paletteForCategoryHandle(item.link.handle) : undefined,
  }))
  if (items.length === 0) return null
  if (section.presentation.variant === "mega") {
    return (
      <SectionFrame section={section} context={context} gut>
        <MegaCategories items={items} />
      </SectionFrame>
    )
  }
  return (
    <SectionFrame section={section} context={context}>
      <CategoryGrid items={items} />
    </SectionFrame>
  )
}
